import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { CollapseContext } from './CollapseContext.js';
import { Box } from '../box/Box.js';

var Collapse = function (_a) {
  var isOpen = _a.isOpen,
    onClick = _a.onClick,
    children = _a.children,
    rest = __rest(_a, ["isOpen", "onClick", "children"]);
  return React__default.createElement(CollapseContext.Provider, {
    value: {
      isOpen: isOpen,
      onClick: onClick
    }
  }, React__default.createElement(Box, __assign({}, rest), children));
};

export { Collapse };
//# sourceMappingURL=Collapse.js.map
